"use client";

import React, { useEffect } from "react";
import styles from "./Payment-Success.module.css";

import { ReactComponent as SuccessIcon } from "../assets/icons/Success.svg";

const PaymentSuccess: React.FC = () => {
  useEffect(() => {
    // درخواست مجوز نوتیف اگر قبلاً داده نشده
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    // بررسی زمان پرداخت
    const deadline = localStorage.getItem("paymentDeadline");

    if (deadline) {
      const deadlineTime = parseInt(deadline, 10);
      const now = Date.now();

      if (now > deadlineTime) {
        // پرداخت با تأخیر انجام شده – نوتیف بده
        if (Notification.permission === "granted") {
          new Notification("یادآوری پرداخت", {
            body: "پرداخت شما با تأخیر انجام شد. در صورت بروز مشکل با پشتیبانی تماس بگیرید.",
          });
        }
      }

      // پاک‌سازی deadline
      localStorage.removeItem("paymentDeadline");
    }
  }, []);

  return (
  
      <div className={styles.container}>
        <div className={styles.topSection}>
          <div className={styles.iconWrapper}>
            <SuccessIcon />
          </div>
          <h2 className={styles.title}>پرداخت با موفقیت انجام شد.</h2>
          <p className={styles.subtitle}>درخواست شما با موفقیت ثبت گردید.</p>
        </div>

        <div className={styles.infoBox}>
          <div className={styles.infoRow}>
            <span className={styles.label}>کد پیگیری</span>
            <span className={styles.value}>1140183884703728434</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>زمان ثبت درخواست</span>
            <span className={styles.value}>1403/05/12 - 10:21</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>مبلغ پرداخت شده</span>
            <span className={styles.value}>310,000 تومان</span>
          </div>
        </div>

        <button
          className={styles.continueButton}
          onClick={() => (window.location.href = "/main")}
        >
          ادامه
        </button>
      </div>
    
  );
};

export default PaymentSuccess;
